import React from "react";
import * as aor from "react-admin";
import TicketCreate from "../../components/TicketCreate";

export default props => (
    <aor.Create {...props}>
        <aor.SimpleForm redirect="show">
            <div>
                <TicketCreate {...props} />
            </div>
            <aor.LongTextInput source="note" />
        </aor.SimpleForm>
    </aor.Create>
);



// WEBPACK FOOTER //
// ./src/resources/Tickets/Create.js